import {Config} from "../Config";
import Role from "./Role";
import toast, { Toaster } from 'react-hot-toast';
import {confirmAlert} from "react-confirm-alert";
import moment from "moment-timezone";
import React from "react";

export var isMockupAPI = false;

export var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

export var validateNumber = /^[0-9]*$/;
export var englishCheck = /^[A-Za-z0-9_]*$/;
//export var validateEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
export var validateEmail = /\S+@\S+\.\S+/;
export var strengthPassword = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{6,}$/;
export var randomString = Math.random().toString(36).slice(2, 7);
export var characterChecked = /^[A-Za-z]*$/;

export function validateUtmSourceCode(char) {
    return characterChecked.test(char.substr(0, 1)) && validateNumber.test(char.substr(1, 1)) && validateNumber.test(char.substr(2, 1)) && validateNumber.test(char.substr(3, 1)) && validateNumber.test(char.substr(4, 1));
}

export var slugString = (str) => {
    return str.replace(/[^a-zA-Z0-9ก-๙-]+/g,'-');
};
export var utmSlug = (str) => {
    return str.replace(/[^a-zA-Z0-9ก-๙-]+/g,'');
};
export var removeSpaceUnderScore = (str) => {
    let text = '';
    if(str) {
        text = str.replace(/\s+/g, '');
        text = text.replace(/_/g, '');
    }
    return text;
};
export var getSpecialSlug = (url) => {
    let domain = '';
    let slug = '';
    let splitSlash = url.split('/');
    if(splitSlash) {

        let protocal = splitSlash[0];
        domain = protocal + '//' +  splitSlash[2];
        //https://www.apthai.com/th/semi-detached-house/baanklangmueng-the-edition-bangna-2
        //https://apthai.com/th/semi-detached-house/baanklangmueng-the-edition-bangna-2
        let replace = url.replace(domain, '');
        if(replace.indexOf('/') > -1) {
            slug = replace.toString().substring(1).replaceAll('/', '-');
            slug = slug.replaceAll('?', '-');
            slug = slug.replaceAll('&', '-');
        }
        else {
            slug = replace;
        }
    }

    return {
        originalUrl: url,
        domain: domain,
        slug: slug
    };
};

//login token
export const LOCAL_STORAGE_KEY = "utmTokens";
export const SUPER_ADMIN_ID = Config.SUPER_ADMIN_ID;

//permission
const roles = new Role();

//fixed from table : menu => menu_id
export const MENU_UTM_TEMPLATE = 1;
export const MENU_UTM_GENERATE = 2;
export const MENU_UTM = 3;
export const MENU_ADSNAMING_GENERATE = 4;
export const MENU_ADSNAMING = 5;
export const MENU_CONTENT_ID = 6;
export const MENU_SETTING_AGENCY = 7;
export const MENU_SETTING_USER = 8;
export const MENU_SETTING_PERMISSION = 9;
export const MENU_CONTENT_CHANEL = 10;
export const MENU_CONTENT_CATEGORY = 11;
export const MENU_CONTENT_BG = 12;
export const MENU_CONTENT_CAMPAIGN_TYPE = 13;
export const MENU_UTM_GROUP = 14;
export const MENU_SETTING_OWNER = 15;
export const MENU_CONTENT_PILLAR = 16;
export const MENU_KOL = 17;
export const MENU_REBRANDLY = 18;
export const MENU_AWS_S3 = 19;
export const MENU_LANG = 20;
export const MENU_BU_TYPE = 22;
export const MENU_PROJECT_TYPE = 21;
export const MENU_ADSNAMING_SETNAME_TYPE = 23;
export const MENU_LEAD_FORM_PROJECT = 24;
export const MENU_LEAD_FORM_CAMPAIGN = 25;
export const MENU_HASTAG = 26;
export const MENU_MASTER_URL = 27;
export const MENU_SHORTIO = 28;
export const MENU_QRCODE_LOGO = 29;
export const MENU_ADS_PLATFORM = 30;
export const MENU_CAMPAIGN_TEMPLATE = 31;
export const MENU_GENERATE_PROJECT = 32;
export const MENU_GENERATE_PROMOTION = 33;
export const MENU_GENERATE_SPECIAL = 34;
export const MENU_GENERATE_MASTER_URL = 35;
export const MENU_GENERATE_GROUP = 36;
export const MENU_AWS_S3_EXPORT = 37;

export const GENERATE_TYPE_PROJECT = 1;
export const GENERATE_TYPE_PROMOTION = 2;
export const GENERATE_TYPE_SPECIAL = 3;
export const GENERATE_TYPE_MASTER_URL = 4;

export const GENERATE_TYPE_UTM = 1;
export const GENERATE_TYPE_CAMPAIGN = 2;
export const GENERATE_TYPE_ADSSET = 3;

export var generateUTMType = (typeId) => {
    if(typeId === GENERATE_TYPE_PROJECT) {
        return 'Project';
    }
    else if(typeId === GENERATE_TYPE_PROMOTION) {
        return 'Promotion';
    }
    else if(typeId === GENERATE_TYPE_SPECIAL) {
        return 'Special';
    }
    else if(typeId === GENERATE_TYPE_MASTER_URL) {
        return 'Master URL';
    }
};

export var generateType = (generateTypeId) => {
    if(generateTypeId === GENERATE_TYPE_CAMPAIGN) {
        return 'Campaign';
    }
    else if(generateTypeId === GENERATE_TYPE_ADSSET) {
        return 'Ads Set';
    }
    else if(generateTypeId === GENERATE_TYPE_UTM) {
        return 'UTM';
    }
};

export const CAMPAIGN_TYPE_ALL = 'all';
export const CAMPAIGN_TYPE_SPECIAL = 'special';
export const timezone = moment().tz('Asia/Bangkok');
export const now = timezone.format('YYYY-MM-DD HH:mm:ss');

export var dateOnly = (dateTimeUTC) => {
  if(dateTimeUTC)
  {
      let date = new Date(dateTimeUTC);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();

      return day + '/' + month + '/' + year;
  }
  else {
      return '';
  }
};

export var getDate = () => {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();

    return year + '' + (month < 10 ? '0':'') + month + '' + (day < 10 ? '0':'') + day;
};

export var getDateTime = () => {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let minute = date.getMinutes();
    let second = date.getSeconds();

    let dateTime = year + '' + (month < 10 ? '0':'') + month + '' + (day < 10 ? '0':'') + day + '' + (hour < 10 ? '0':'') + hour + '' + (minute < 10 ? '0':'') + minute + '' + (second < 10 ? '0':'') + second;
    return dateTime;
};
export const getFileName = () => {
    let name = getDateTime() + randomString;
    return name;
};

export var dateYMD = (dateTimeUTC, split = '/') => {
    if(dateTimeUTC)
    {
        let date = new Date(dateTimeUTC);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();

        return year + split + (month < 10 ? '0':'') + month + split + (day < 10 ? '0':'') + day;
    }
    else {
        return '';
    }
};

export var dateYMDHI = (dateTimeUTC, split = '/') => {
    if(dateTimeUTC)
    {
        let date = new Date(dateTimeUTC);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let minute = date.getMinutes();

        hour = (hour < 10 ? '0':'') + hour;
        minute = (minute < 10 ? '0':'') + minute;

        return year + split + (month < 10 ? '0':'') + month + split + (day < 10 ? '0':'') + day + ' ' + hour + ':' + minute;
    }
    else {
        return '';
    }
};

export var dateTime = (dateTimeUTC) => {
    if(dateTimeUTC)
    {
        let date = new Date(dateTimeUTC);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let minute = date.getMinutes();

        hour = (hour < 10 ? '0':'') + hour;
        minute = (minute < 10 ? '0':'') + minute;

        return <>{day}/{month}/{year}<span className="small d-block text-muted">{hour}:{minute}</span></>;
    }
    else {
        return '';
    }
};

export var dateTime2 = (dateTimeUTC) => {
    if(dateTimeUTC)
    {
        let date = new Date(dateTimeUTC);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let minute = date.getMinutes();

        hour = (hour < 10 ? '0':'') + hour;
        minute = (minute < 10 ? '0':'') + minute;

        return <>{day}/{month}/{year} <span className="small text-muted">{ hour}:{minute}</span></>;
    }
    else {
        return '';
    }
};

// var Base64 = {
//     encode: function(s) {
//         return btoa(unescape(encodeURIComponent(s)));
//     },
//     decode: function(s) {
//         return decodeURIComponent(escape(atob(s)));
//     }
// };
export var encodeItem = (json) => {
    return window.btoa(encodeURIComponent(JSON.stringify(json)));
};
export var decodeItem = (encodeStr) => {
    let str = decodeURIComponent(window.atob(encodeStr));
    return JSON.parse(str);
};

export function listingByUserId(endPointPath, params = {}) {
    const roles = new Role();
    params.createdBy = roles.loginUserId;
    return fetch(Config.url.API_URL + endPointPath, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify(params)
    });
}

//ex 7/9/22
export var dateFromExcel = (str) => {
    if(str)
    {
        let split = str.split('/');
        let day = split[1];
        let month = split[0];
        let year = split[2];

        if(year && year.length && month && month.length && day && day.length) {
            return (year.length === 2 ? (parseInt(year)+2000):year) + '-' + (month < 10 ? '0':'') + month + '-' + (day < 10 ? '0':'') + day;
        }
        else {
            return false;
        }
    }
    else {
        return '';
    }
};

//------ Ads Naming -------------------------------------------------------- //
export const ADSNAMING_TYPE_SLUG_PROJECT = 1;
export const ADSNAMING_TYPE_FREEFORM = 2;
export const ADSNAMING_TYPE_SLUG_PROMOTION = 3;
export const ADSNAMING_TYPE_KOL_PAGE = 4;
export const ADSNAMING_TYPE_SLUG_SPECIAL = 5;

export const ADSNAMING_GROUP_ALWAYS_ON = 1;
export const ADSNAMING_GROUP_ADHOC_CAMPAIGN = 2;
export const ADSNAMING_GROUP_SPECIAL = 3;
export var adsNamingCampaignTypeName = (typeId) => {
    if(typeId === ADSNAMING_GROUP_ALWAYS_ON) {
        return 'Project';
    }
    else if(typeId === ADSNAMING_GROUP_ADHOC_CAMPAIGN) {
        return 'Promotion';
    }
    else if(typeId === ADSNAMING_GROUP_SPECIAL) {
        return 'Special';
    }
};

export const ADSNAMING_TYPE_CAMPAIGN = 1;
export const ADSNAMING_TYPE_SETNAME = 2;
export const ADSNAMING_TYPE_CREATIVE = 3;
export var adsNamingTypeName = (typeId) => {
    if(typeId === ADSNAMING_TYPE_CAMPAIGN) {
        return 'Campaign';
    }
    else if(typeId === ADSNAMING_TYPE_SETNAME) {
        return 'SetName';
    }
    else if(typeId === ADSNAMING_TYPE_CREATIVE) {
        return 'Creative';
    }
};

export const ADS_NAMING_SPECIAL_FILTER_BG_ZONE = 1;
export const ADS_NAMING_SPECIAL_FILTER_COMBINE_ZONE = 2;
export const ADS_NAMING_SPECIAL_FILTER_EVENT_REMINDER = 3;
export const ADS_NAMING_SPECIAL_FILTER_STATIC_PAGE = 4;
export async function getAdsNamingSpecialFilter() {
    let json = {
        "result": "000",
        "message": "success",
        "data": [
            {
                "id": ADS_NAMING_SPECIAL_FILTER_BG_ZONE,
                "name": "BG Zone",
            },
            {
                "id": ADS_NAMING_SPECIAL_FILTER_COMBINE_ZONE,
                "name": "Combine Zone",
            },
            {
                "id": ADS_NAMING_SPECIAL_FILTER_EVENT_REMINDER,
                "name": "Event Reminder",
            },
            {
                "id": ADS_NAMING_SPECIAL_FILTER_STATIC_PAGE,
                "name": "Static Page",
            }
        ]
    };
    let response = JSON.parse(JSON.stringify(json));
    return response.data;
}

export const ADS_NAMING_ZONE_STATUS_ACTIVE = 'active';
export const ADS_NAMING_ZONE_STATUS_HIDDEN = 'hidden';
export async function getAdsNamingZoneStatus() {
    let json = {
        "result": "000",
        "message": "success",
        "data": [
            {
                "id": ADS_NAMING_ZONE_STATUS_ACTIVE,
                "name": "active",
            },
            {
                "id": ADS_NAMING_ZONE_STATUS_HIDDEN,
                "name": "hidden",
            }
        ]
    };
    let response = JSON.parse(JSON.stringify(json));
    return response.data;
}

//------ UTM -------------------------------------------------------- //
export const UTM_SOURCE_DEFAULT_CHECKED = 1;
export const UTM_SOURCE_DEFAULT_UNCHECKED = 2;

//------ Content ID -------------------------------------------------------- //
export var contentIdGenerater = (row) => {
    let contentId = '';

    let ownerCode = row.owner ? row.owner.code : '--';

    let postDate = row.postDate;
    let split = postDate.split('-');
    let day = split[2];
    let month = split[1];
    let year = split[0];
    let newPostDate = day + month + year.substr(2, 2);

    let camapaignStatus = row.status === 1 ? 1:0;
    let bgCode = row.bg ? row.bg.code : '--';

    var sprintf = require('sprintf-js').sprintf;
    let id = sprintf('%04d', row.id);

    contentId = ownerCode + newPostDate + camapaignStatus + bgCode + id;

    return contentId;
};
export const CONTENT_TYPE_ADHOC = 1;
export const CONTENT_TYPE_SUPPORT = 2;
export const CONTENT_TYPE_NON = 3;  
export async function getContentIdType() {
    let json = {
        "result": "000",
        "message": "success",
        "data": [
            {
                "id": CONTENT_TYPE_ADHOC,
                "name": "Adhoc",
            },
            {
                "id": CONTENT_TYPE_SUPPORT,
                "name": "Support",
            },
            {
                "id": CONTENT_TYPE_NON,
                "name": "Non",
            }
        ]
    };
    let response = JSON.parse(JSON.stringify(json));
    return response.data;
}

//------ API TypeID -------------------------------------------------------- //
export const API_TYPE_CONTENT_ID = 1;
export const API_TYPE_PROJECT_SLUG = 2;
export const API_TYPE_CAMPAIGN_ID = 3;
export const API_TYPE_PROMOTION_SLUG = 4;
export const API_TYPE_PROJECT_ID = 5;
export const API_TYPE_PROJECT_NAME = 6;
export const API_TYPE_CAMPAIGN_NAME = 7;
export const API_TYPE_OWNER_ID = 8;
export const API_TYPE_LINE_OAID = 9;
export const utmSourceInputType = (typeId) => {
    if(typeId === API_TYPE_CONTENT_ID) {
        return 'Master File : Content ID';
    }
    else if(typeId === API_TYPE_PROJECT_SLUG) {
        return 'AP API : Project Slug';
    }
    else if(typeId === API_TYPE_CAMPAIGN_ID) {
        return 'AP API : Campaign ID';
    }
    else if(typeId === API_TYPE_PROMOTION_SLUG) {
        return 'AP API : Promotion Slug';
    }
    else if(typeId === API_TYPE_PROJECT_ID) {
        return 'AUTO : Project ID';
    }
    else if(typeId === API_TYPE_PROJECT_NAME) {
        return 'AUTO : Project Name';
    }
    else if(typeId === API_TYPE_CAMPAIGN_NAME) {
        return 'AUTO : Campaign Name';
    }
    else if(typeId === API_TYPE_OWNER_ID) {
        return 'Master File : Owner ID';
    }
    else if(typeId === API_TYPE_LINE_OAID) {
        return 'AUTO : Project LINE OAID';
    }
    else {
        return 'Default/Dropdown';
    }
};


//------ Short URL -------------------------------------------------------- //
export async function getRebrandlyShortURL(data, fullUrl) {
    const response = await fetch(data.endpoint, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'apikey': data.apiKey
        },
        body: JSON.stringify({
            destination: encodeURI(fullUrl),
            domain: {
                fullName : data.domain ?? null
            }
        })
    });

    if(response.ok) { 
        return response.json();
    }
    else {
        return response.json().then(err => {
            toast.error('Short Link Notic : '  + err.errors[0].message);
        });
        //return response.json().then(err => Promise.reject(err));
    }
}
export async function getRebrandly() {
    const response = await fetch(Config.url.API_URL +'/api/rebrandly/view', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            id: 1
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}

export async function getShortIO() {
    const response = await fetch(Config.url.API_URL +'/api/shortio/view', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            id: 1
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}

export async function createShortioShortURL(originalURL) {
    const response = await fetch(Config.url.API_URL +'/api/shortio/createShortUrl', {
        method: 'POST',
        headers: {
            'Content-Type':'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            originalURL: originalURL
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => {
            toast.error('Short Link Notic : '  + err.errors[0].message);
        });
        //return response.json().then(err => Promise.reject(err));
    }
}

export async function updateShortioShortURL(shortURL) {
    const response = await fetch(Config.url.API_URL +'/api/shortio/updateShortUrl', {
        method: 'POST',
        headers: {
            'Content-Type':'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            shortURL: shortURL
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => {
            toast.error('Short Link Notic : '  + err.errors[0].message);
        });
        //return response.json().then(err => Promise.reject(err));
    }
}

//------ Get From DB -------------------------------------------------------- //
export async function getOwner(params = null) {
    const response = await fetch(Config.url.API_URL +'/api/owner/listingName', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            agencyId: params ? params.agencyId : null
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getOwnerAll() {
    const response = await fetch(Config.url.API_URL +'/api/owner/listingAll', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export function showOwner(items) {
    let result = [];
    if(items) {
        items.map(item => {
            if(item.data) {
                result.push({
                    name: item.data.name
                });
            }
        });
    }
    return result;
}
export async function getAgency(params = null) {
    const response = await fetch(Config.url.API_URL +'/api/agency/listingName', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            id: params ? params.agencyId : null
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getAgencySlug(params = null) {
    const response = await fetch(Config.url.API_URL +'/api/agency/listingSlug', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            id: params ? params.agencyId : null
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getAgencyView(agencyId) {
    const response = await fetch(Config.url.API_URL +'/api/agency/view', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            id: agencyId
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export function onReorder(path, data) {
    let items = [];
    for (let i=0;i<data.length;i++) {
        let orderIds = document.getElementsByName('orderIds'+data[i].id);
        items.push({
            id: data[i].id,
            orderId: orderIds[0].value ? parseInt(orderIds[0].value) : 0
        });
    }
    if(items.length) {
        fetch(Config.url.API_URL + '/api/' + path + '/updateOrder', {
            method: 'POST',
            body: JSON.stringify({
                items: items,
                updatedBy: roles.loginUserId
            }),
            headers: {
                'Content-Type':'application/json',
                'x-access-token': roles.accessToken
            }
        }).then(response => {
            if(response.ok) {
                return response.json();
            }
            else {
                return response.json().then(err => Promise.reject(err));
            }
        }).then(result => {
            if(result) {
                toast.success("อัพเดตข้อมูลเรียบร้อย", {autoClose: 2000});
                setTimeout(function () {
                    window.location.reload();
                }, 1000);
            }
        }).catch(err => {
            toast.error(err.message);
        })
    }
}
export async function onChangeOrder(e, item, data, setData) {
    let tempData = [...data];
    tempData.map((rs) => {
        if(item.id === rs.id) {
            rs.orderId = e.target.value;
        }
        return rs;
    });
    setData(tempData);
}
export function setStatus(path, itemId) {
    //'/api/agency/updateStatus'
    fetch(Config.url.API_URL + '/api/' + path + '/updateStatus', {
        method: 'POST',
        body: JSON.stringify({id: itemId}),
        headers: {
            'Content-Type':'application/json',
            'x-access-token': roles.accessToken
        }
    }).then(response => {
        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }).then(result => {
        if(result) {
            //toast.success("อัพเดตข้อมูลเรียบร้อย", {autoClose: 2000});
            //getData();
        }
    }).catch(err => {
        toast.error(err.message);
    })
}
export async function onStatusClick(e, item, data, setData, path) {
    confirmAlert({
        title: 'แจ้งเตือน',
        message: 'ต้องการอัพเดตสถานะ ?',
        buttons: [
            {
                label: 'ตกลง',
                onClick: () => {
                    let tempData = [...data];
                    tempData.map((rs) => {
                        if(item.id === rs.id) {
                            rs.status = rs.status===1 ? 2:1;
                            setStatus(path, item.id);
                        }
                        return rs;
                    });
                    setData(tempData);
                    toast.success("อัพเดตสถานะเรียบร้อย");
                }
            },
            {
                label: 'ยกเลิก',
                onClick: () => {}
            }
        ]
    });
}
export async function deleteItem(path, itemId, itemTitle = '') {
    confirmAlert({
        title: 'แจ้งเตือน',
        message: 'ต้องการลบรายการนี้ : ' + (itemTitle ? itemTitle : 'id=' + itemId),
        buttons: [
            {
                label: 'ตกลง',
                onClick: () => {
                    fetch(Config.url.API_URL +'/api/' + path+ '/delete', {
                        method: 'POST',
                        body: JSON.stringify({id: itemId}),
                        headers: {
                            'Content-Type':'application/json',
                            'x-access-token': roles.accessToken
                        }
                    }).then(response => {
                        if(response.ok) {
                            return response.json();
                        }
                        else {
                            return response.json().then(err => Promise.reject(err));
                        }
                    }).then(result => {
                        if(result) {
                            document.getElementById('rowId' + itemId).remove();
                            toast.success("ลบข้อมูลเรียบร้อย", {autoClose: 2000});
                            // getDataSearch({
                            //     name : name ?? null,
                            //     email : email ?? null,
                            //     sortField: sortField ?? null,
                            //     sortType: sortType ?? null,
                            //     activePage: 1,
                            // });
                        }
                    }).catch(err => {
                        toast.error(err.message);
                    })
                }
            },
            {
                label: 'ยกเลิก',
                onClick: () => {}
            }
        ]
    });
}

export async function getLanguage() {
    const response = await fetch(Config.url.API_URL +'/api/lang/listingName', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getCampaignType() {
    let json = {
        "result": "000",
        "message": "success",
        "data": [
            {
                "id": CAMPAIGN_TYPE_ALL,
                "name": "All",
            },
            {
                "id": CAMPAIGN_TYPE_SPECIAL,
                "name": "Special",
            }
        ]
    };
    let response = JSON.parse(JSON.stringify(json));
    return response.data;
}
export async function getType() {
    let json = {
        "result": "000",
        "message": "success",
        "data": [
            {
                "id": GENERATE_TYPE_PROJECT,
                "name": "Project",
            },
            {
                "id": GENERATE_TYPE_PROMOTION,
                "name": "Promotion",
            },
            {
                "id": GENERATE_TYPE_SPECIAL,
                "name": "Special",
            },
            {
                "id": GENERATE_TYPE_MASTER_URL,
                "name": "Master URL",
            }
        ]
    };
    let response = JSON.parse(JSON.stringify(json));
    return response.data;
}
export async function getAdsCampaignType() {
    let json = {
        "result": "000",
        "message": "success",
        "data": [
            {
                "id": ADSNAMING_GROUP_ALWAYS_ON,
                "name": adsNamingCampaignTypeName(ADSNAMING_GROUP_ALWAYS_ON),
            },
            {
                "id": ADSNAMING_GROUP_ADHOC_CAMPAIGN,
                "name": adsNamingCampaignTypeName(ADSNAMING_GROUP_ADHOC_CAMPAIGN),
            },
            {
                "id": ADSNAMING_GROUP_SPECIAL,
                "name": adsNamingCampaignTypeName(ADSNAMING_GROUP_SPECIAL),
            }
        ]
    };
    let response = JSON.parse(JSON.stringify(json));
    return response.data;
}
export async function getAdsType() {
    let json = {
        "result": "000",
        "message": "success",
        "data": [
            {
                "id": ADSNAMING_GROUP_ALWAYS_ON,
                "name": adsNamingCampaignTypeName(ADSNAMING_GROUP_ALWAYS_ON),
            },
            {
                "id": ADSNAMING_GROUP_ADHOC_CAMPAIGN,
                "name": adsNamingCampaignTypeName(ADSNAMING_GROUP_ADHOC_CAMPAIGN),
            },
            {
                "id": ADSNAMING_GROUP_SPECIAL,
                "name": adsNamingCampaignTypeName(ADSNAMING_GROUP_SPECIAL),
            }
        ]
    };
    let response = JSON.parse(JSON.stringify(json));
    return response.data;
}
export async function getBuType() {
    const response = await fetch(Config.url.API_URL +'/api/buType/listingName', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getBuTypeView(code = null) {
    const response = await fetch(Config.url.API_URL +'/api/buType/view', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            code: code ?? null
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getProjectType() {
    const response = await fetch(Config.url.API_URL +'/api/projectType/listingName', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getKol() {
    const response = await fetch(Config.url.API_URL +'/api/adsNamingKol/listingName', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getKolView(id) {
    const response = await fetch(Config.url.API_URL +'/api/adsNamingKol/view', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            id: id
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getAdsNamingSetNameType() {
    const response = await fetch(Config.url.API_URL +'/api/adsNamingSetNameType/listingName', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getAdsNamingSetNameTypeView(id) {
    const response = await fetch(Config.url.API_URL +'/api/adsNamingSetNameType/view', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            id: id
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
// -------- Get UTM --------------
export async function getUtm() {
    const response = await fetch(Config.url.API_URL +'/api/utm/listingName', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getTemplate(params = null) {
    const response = await fetch(Config.url.API_URL +'/api/utmTemplate/listingName', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            agencyId: params ? params.agencyId : null
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getAdsCampaignGroup(typeId) {
    const response = await fetch(Config.url.API_URL +'/api/adsCampaignGroup/listingName', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            typeId: typeId
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getAdsSetnameGroup(typeId) {
    const response = await fetch(Config.url.API_URL +'/api/adsSetnameGroup/listingName', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            typeId: typeId
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getGroup() {
    const response = await fetch(Config.url.API_URL +'/api/utmGroup/listingName', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            agencyId: roles.agencyId
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getGroupById(id) {
    const response = await fetch(Config.url.API_URL +'/api/utmGroup/view', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            id: id
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getGroupItemView(groupItemId) {
    const response = await fetch(Config.url.API_URL +'/api/utmGroupItem/view', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            id: groupItemId
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getUtmByIds(resSource) {
    if(resSource) {
        let ids = [];
        for(let id of resSource) {
            ids.push(id.utmId);
        }
        const response = await fetch(Config.url.API_URL +'/api/utm/listingName', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                ids: [...new Set(ids)]
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }
}
export async function getGroupByTemplate(tpId){
    const response = await fetch(Config.url.API_URL +'/api/utmGroup/listingName', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            utmTemplateId: tpId,
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getGroupItemByGroup(groupId) {
    const response = await fetch(Config.url.API_URL +'/api/utmGroupItem/listingName', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            utmGroupId: groupId,
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getTemplateSourceById(utmTemplateId) {
    const response = await fetch(Config.url.API_URL +'/api/utmTemplateSource/listing', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            id: utmTemplateId,
            agencyId: roles.agencyId
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getUtmSourceTypeById(id) {
    const response = await fetch(Config.url.API_URL +'/api/utmSourceType/view', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            id: id
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getUtmSourceType() {
    const response = await fetch(Config.url.API_URL +'/api/utmSourceType/listingName', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({

        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getUtmSourceById(id) {
    const response = await fetch(Config.url.API_URL +'/api/utmSource/view', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            id: id
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getContentId(params = null) {
    const response = await fetch(Config.url.API_URL + '/api/contentId/listingName', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            ownerId: params ? params.ownerId : null,
            postDate: params ? dateYMD(params.postDate, '-') : null,
            agencyId: params ? params.agencyId : null,
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getContentIdView(contentId) {
    const response = await fetch(Config.url.API_URL + '/api/contentId/view', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            id: contentId
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getContentIdByCode(code) {
    const response = await fetch(Config.url.API_URL + '/api/contentId/viewCode', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            contentId: code
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getOwnerView(ownerId) {
    const response = await fetch(Config.url.API_URL + '/api/owner/view', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            id: ownerId
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getOwnerViewByCode(code) {
    const response = await fetch(Config.url.API_URL + '/api/owner/viewByCode', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            code: code
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getOwnerRunningView(code) {
    const response = await fetch(Config.url.API_URL + '/api/ownerRunningCode/viewByCode', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            code: code
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getOwnerRunningId(ownerId) {
    const response = await fetch(Config.url.API_URL + '/api/ownerRunningCode/lastCode', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            ownerId: ownerId
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export var getOwnerRunningCode = (id, num) => {
    let places = 14;
    var zero = places - num.toString().length + 1;
    let running = Array(+(zero > 0 && zero)).join("0") + num;
    return id + running;
};

export async function getUtmSourceTypeForParam(sourceTypeIds) {
    const response = await fetch(Config.url.API_URL +'/api/utmSourceType/listingPreview', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            utmSourceTypeIds: sourceTypeIds,
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function generateParams(params = null, customSourceTypeIds = null, idx = -1, m = -1, n = -1) {
    let typeId = null;
    let campaignTypeId = null;
    let buTypeId = null;
    let langId = null;
    let newPromotionSlug = null;
    if(params) {
          typeId = params.typeId ? params.typeId.id : null;
          campaignTypeId = params.campaignTypeId ? params.campaignTypeId.id : null;
          buTypeId = params.buTypeId ? params.buTypeId.id : null;
          langId = params.langId ? params.langId.id : null;
          newPromotionSlug = params.newPromotionSlug ?? false;
    }

    let selectSourceTypeIds = null;
    if(idx >= 0 && m >= 0 && n >= 0) {
        selectSourceTypeIds = document.getElementsByName('sourceTypeIds[' + n + '][' + m + '][' + idx + '][]');
    }
    else if(idx >= 0 && m >= 0) {
        selectSourceTypeIds = document.getElementsByName('sourceTypeIds[' + m + '][' + idx + '][]');
    }
    else if(idx >= 0) {
        selectSourceTypeIds = document.getElementsByName('sourceTypeIds[' + idx + '][]');
    }
    else {
        selectSourceTypeIds = document.getElementsByName('sourceTypeIds[]');
    }
    if(customSourceTypeIds) {
        selectSourceTypeIds = customSourceTypeIds;
    }

    let sourceTypeIdsAll = [];
    let sourceTypeIdsParam = [];
    let contentIdsParam = []; // Content ID
    let ownerIdsParam = []; // Owner ID
    let campaignIdsParam = []; // Campaign Id
    let campaignNameParam = []; // Campaign Name
    let projectIdsParam = []; // Project ID
    let projectNamesParam = []; // Project Name
    let projectSlugIdsParam = []; // Project Slug
    let promotionSlugIdsParam = []; // Promotion Slug
    let lineOAIdsParam = []; // LINE OAID
    if(selectSourceTypeIds) {
        for(let st of selectSourceTypeIds) {
            if(st) {
                let utmSourceTypeId = '';
                if(customSourceTypeIds) {
                    utmSourceTypeId = st.toString();
                }
                else {
                    utmSourceTypeId = st.value;
                }

                if(utmSourceTypeId) {
                    if(utmSourceTypeId.includes(':CID')) {
                        contentIdsParam.push(utmSourceTypeId);
                    }
                    else if(utmSourceTypeId.includes(':OID')) {
                        ownerIdsParam.push(utmSourceTypeId);
                    }
                    else if(utmSourceTypeId.includes(':CP')) {
                        campaignIdsParam.push(utmSourceTypeId);
                    }
                    else if(utmSourceTypeId.includes(':CN')) {
                        campaignNameParam.push(utmSourceTypeId);
                    }
                    else if(utmSourceTypeId.includes(':PJI')) {
                        projectIdsParam.push(utmSourceTypeId);
                    }
                    else if(utmSourceTypeId.includes(':PJN')) {
                        projectNamesParam.push(utmSourceTypeId);
                    }
                    else if(utmSourceTypeId.includes(':PJS')) {
                        projectSlugIdsParam.push(utmSourceTypeId);
                    }
                    else if(utmSourceTypeId.includes(':PMS')) {
                        promotionSlugIdsParam.push(utmSourceTypeId);
                    }
                    else if(utmSourceTypeId.includes(':LINEOA')) {
                        lineOAIdsParam.push(utmSourceTypeId);
                    }
                    else {
                        sourceTypeIdsParam.push(utmSourceTypeId);
                    }
                    sourceTypeIdsAll.push(utmSourceTypeId);
                }
            }
        }
    }

    if(sourceTypeIdsAll.length > 0) {
        //STEP 1 : Get Source Type Name
        let sourceTypeIds = await getUtmSourceTypeForParam(sourceTypeIdsParam);

        //STEP 1.1 : Get Content ID
        for(let cs of contentIdsParam) {
            let sp = cs.split(':CID');
            let contentId = sp[0];
            let utmSourceId = sp[1];
            let resUtmSource = await getUtmSourceById(utmSourceId);
            if(contentId !== 'x') {
                let resContent = await getContentIdView(contentId);
                let contentIdCode = contentIdGenerater(resContent);
                sourceTypeIds.push({
                    id: cs,
                    name: contentIdCode,
                    utmId: resUtmSource.utmId,
                    utm: resUtmSource.utm
                });
            }
            else {
                sourceTypeIds.push({
                    id: cs,
                    name: '{contentId}',
                    utmId: resUtmSource.utmId,
                    utm: resUtmSource.utm
                });
            }
        }

        //STEP 1.2 : Get Owner ID
        for(let cs of ownerIdsParam) {
            let sp = cs.split(':OID');
            let ownerId = sp[0];
            let utmSourceId = sp[1];
            let resUtmSource = await getUtmSourceById(utmSourceId);
            if(ownerId !== 'x') {
                let resOwner = await getOwnerView(ownerId);
                let ownerCodeRow = await getOwnerRunningId(ownerId);
                let ownerRunningCode = getOwnerRunningCode(resOwner.code, ownerCodeRow.code ?? 1);

                sourceTypeIds.push({
                    id: cs,
                    name: ownerRunningCode,
                    utmId: resUtmSource.utmId,
                    utm: resUtmSource.utm
                });
            }
            else {
                sourceTypeIds.push({
                    id: cs,
                    name: '{ownerId}',
                    utmId: resUtmSource.utmId,
                    utm: resUtmSource.utm
                });
            }
        }

        //STEP 1.3 : Get Campaign Id
        for(let cs of campaignIdsParam) {
            let sp = cs.split(':CP');
            let campaignId = sp[0];
            let utmSourceId = sp[1];
            let resUtmSource = await getUtmSourceById(utmSourceId);

            sourceTypeIds.push({
                id: cs,
                name: campaignId !== 'x' ? campaignId : '{campaignId}',
                utmId: resUtmSource.utmId,
                utm: resUtmSource.utm
            });
        }

        //STEP 1.4 : Get Campaign Name
        for(let cs of campaignNameParam) {
            let sp = cs.split(':CN');
            let campaignName = sp[0];
            let utmSourceId = sp[1];
            let resUtmSource = await getUtmSourceById(utmSourceId);
            sourceTypeIds.push({
                id: cs,
                name: campaignName !== 'x' ? campaignName : '{campaignName}',
                utmId: resUtmSource.utmId,
                utm: resUtmSource.utm
            });
        }

        //STEP 1.5 : Get Project ID
        for(let cs of projectIdsParam) {
            let sp = cs.split(':PJI');
            let projectCode = sp[0];
            let utmSourceId = sp[1];
            let resUtmSource = await getUtmSourceById(utmSourceId);
            sourceTypeIds.push({
                id: cs,
                name: projectCode !== 'x' ? projectCode : '{projectId}',
                utmId: resUtmSource.utmId,
                utm: resUtmSource.utm
            });
        }

        //STEP 1.6 : Get Project Name
        for(let cs of projectNamesParam) {
            let sp = cs.split(':PJN');
            let projectName = sp[0];
            let utmSourceId = sp[1];
            let resUtmSource = await getUtmSourceById(utmSourceId);
            sourceTypeIds.push({
                id: cs,
                name: projectName !== 'x' ? projectName : '{projectName}',
                utmId: resUtmSource.utmId,
                utm: resUtmSource.utm
            });
        }

        //STEP 1.7 : Get Project Slug
        for(let cs of projectSlugIdsParam) {
            let sp = cs.split(':PJS');
            let projectSlug = sp[0];
            let utmSourceId = sp[1];
            let resUtmSource = await getUtmSourceById(utmSourceId);
            sourceTypeIds.push({
                id: cs,
                name: projectSlug !== 'x' ? projectSlug : '{projectSlug}',
                utmId: resUtmSource.utmId,
                utm: resUtmSource.utm
            });
        }

        //STEP 1.8 : Get Promotion Slug
        for(let cs of promotionSlugIdsParam) {
            let sp = cs.split(':PMS');
            let promotionSlug = sp[0];
            let utmSourceId = sp[1];
            let resUtmSource = await getUtmSourceById(utmSourceId);

            //Replace Params
            if(newPromotionSlug) {
                promotionSlug = await getPromotionSlug({
                    buTypeId: buTypeId,
                    campaignTypeId: campaignTypeId,
                    langId: langId,
                    promotionSlug: promotionSlug
                });
            }

            sourceTypeIds.push({
                id: cs,
                name: promotionSlug !== 'x' ? promotionSlug : '{promotionSlug}',
                utmId: resUtmSource.utmId,
                utm: resUtmSource.utm
            });
        }

        //STEP 1.8 : Get Line OA
        for(let cs of lineOAIdsParam) {
            let sp = cs.split(':LINEOA');
            let lineOAUrl = sp[0];
            let utmSourceId = sp[1];
            let resUtmSource = await getUtmSourceById(utmSourceId);
            sourceTypeIds.push({
                id: cs,
                name: lineOAUrl !== 'x' ? lineOAUrl : '{lineOAUrl}',
                utmId: resUtmSource.utmId,
                utm: resUtmSource.utm
            });
        }

        //STEP 2 : Merge
        let utmMerge = [];
        for(let id of sourceTypeIdsAll) {
            let find = sourceTypeIds.find(rs => {
                if((!id.includes(':') && rs.id === parseInt(id)) || (id.includes(':') && rs.id === id)) {
                    return rs;
                }
            });
            if(find) {
                let name = find.name;
                if(find.utmSource?.isEncrypt) {
                    const resAgency = await getAgency({agencyId: roles.agencyId});
                    if(resAgency && resAgency[0].isEncrypt === 1) {
                        name = find.utmSource?.prefix + '' + find.code;
                    }
                }
                utmMerge.push({
                    utmId: find.utmId,
                    utmName: find.utm.name ?? id,
                    name: name,
                    utmPrefix: find.utm.utmPrefix
                });
            }
        }

        //STEP 3 : Get utm
        let utmNames = [];
        for(let s of utmMerge) {
            let utmId = s.utmId;
            let utmName = s.utmName;
            utmNames[utmId] = (s.utmPrefix === 1 ? 'utm_' : '') + utmName.toLowerCase();
        }

        //STEP 4 : Merge group
        const map = new Map(utmMerge.map(({utmId, name}) => [utmId, { utmId, name: [] }]));
        for (let {utmId, name} of utmMerge) map.get(utmId).name.push(...[name].flat());

        //STEP 5 : Join group
        let newArr = [];
        for(let arr of [...map.values()]) {
            if(arr.utmId) {
                newArr.push(utmNames[arr.utmId] + '=' + arr.name.join('_'));
            }
        }

        let filtered = newArr.filter(function (el) {
            return el != null;
        });

        return filtered.join('&');
    }
    else {
        toast.error("กรุณาเลือก UTM หรือ Group Item");
        return '';
    }
}
export async function getPromotionSlug(params = null) {
    let buTypeId = params ? params.buTypeId : null;
    let campaignTypeId = params ? params.campaignTypeId : null;
    let langId = params ? params.langId : null;
    let promotionSlug = params ? params.promotionSlug : null;
    let newPromotionSlug = '';
    let buTypeRow = await getBuTypeView(buTypeId);

    if(buTypeId && campaignTypeId && langId && promotionSlug) {
        if(buTypeRow) {
            let replace = buTypeRow.replace;
            if(campaignTypeId === CAMPAIGN_TYPE_ALL) {
                //th-promotion-townhome-th-10-new-projects"
                //{lang}-promotion-townhome-{promotion_slug} Example : th-promotion-townhome-all-bkm
                newPromotionSlug = langId + '-promotion-' + replace + '-' + (promotionSlug !== 'x' ? promotionSlug : '{promotionSlug}');
            }
            else if(campaignTypeId === CAMPAIGN_TYPE_SPECIAL) {
                //{lang}-townhome-zone-{promotion_slug} Example : th-townhome-zone-all-bkm
                newPromotionSlug = langId + '-' + replace + '-zone-' + (promotionSlug !== 'x' ? promotionSlug : '{promotionSlug}');
            }
        }
        else {
            newPromotionSlug = '{lang}-{bu type replace}-{promotion or zone}-{promotionSlug}';
        }
    }

    return newPromotionSlug;
}
export async function getProjectNameSlug(params = null) {
    let projectName = '';
    if(params) {
        if(params.langId && params.project_type_slug && params.project_slug) {
            projectName = params.langId + '-' + params.project_type_slug + '-' + params.project_slug;
        }
    }
    return projectName;
}
// ----- GET AP API -----------------
export async function getListSubCampaign() {
    if(isMockupAPI) {
        let json = {"result":"000","message":"success","campaign":[{"sub_campaign_id":"0085A05","sub_campaign_name":"Online MKT Search 2024_All","campaign_type":"All","project_type":"Special","type_id":null,"start_date":"2024-07-01T00:00:00Z","end_date":"2024-12-31T00:00:00Z","project":["40099","AQ0001","20042","70082","70009","40058","10131","60035","AP0001"]},{"sub_campaign_id":"0721Z09","sub_campaign_name":"TH_SEM NON BRAND_2023_Zone_TH-Nonbrand โซน ลาดพร้าว-รามอินทรา_ทาวน์โฮม โซนลาดพร้าว-รามอินทรา","campaign_type":"Special","project_type":"townhome","type_id":"Z0062","start_date":"2023-01-01T00:00:00Z","end_date":"2024-12-31T00:00:00Z","project":["10194","10214","20018","20030","70048","70060","70069","40102"]}]};
        let response = JSON.parse(JSON.stringify(json));
        return response;
    }
    else {
        const response = await fetch(Config.url.AP_API_URL + '/api/cm/listsubcampaign', {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-key': Config.AP_API_KEY
            }
        });

        if (response.ok) {
            return response.json();
        } else {
            return response.json().then(err => {
                let msg = err.message;
                if (msg instanceof Array) {
                    toast.error(msg.join(', '));
                } else {
                    toast.error(err.message);
                }
            });
        }
    }
}
export async function getListSubCampaignImport() {
    if(isMockupAPI) {
        let json = {
            "statusCode": 200,
            "message": "display information successfully!",
            "code": "success",
            "campaign": [{
                "sub_campaign_id": "0085A05",
                "sub_campaign_name": "Online MKT Search 2024_All",
                "campaign_type": "All",
                "project_type": "Special",
                "type_id": null,
                "start_date": "2024-07-01T00:00:00Z",
                "end_date": "2024-12-31T00:00:00Z",
                "project": ["40099", "AQ0001", "20042", "70082", "70009", "40058", "10131", "60035", "AP0001"]
            }, {
                "sub_campaign_id": "0721Z09",
                "sub_campaign_name": "TH_SEM NON BRAND_2023_Zone_TH-Nonbrand โซน ลาดพร้าว-รามอินทรา_ทาวน์โฮม โซนลาดพร้าว-รามอินทรา",
                "campaign_type": "Special",
                "project_type": "townhome",
                "type_id": "Z0062",
                "start_date": "2023-01-01T00:00:00Z",
                "end_date": "2024-12-31T00:00:00Z",
                "project": ["10194", "10214", "20018", "20030", "70048", "70060", "70069", "40102"]
            }]
        };
        let response = JSON.parse(JSON.stringify(json));
        return response;
    }
    else {
        const response = await fetch(Config.url.AP_API_URL + '/api/cm/listsubcampaign', {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-key': Config.AP_API_KEY
            }
        });

        return response.json();
    }
}

export async function getProjectCode(lang, project_type) {
    if(isMockupAPI) {
        let json = {
            "statusCode": 200,
            "message": "display information successfully!",
            "code": "success",
            "data": [{
                "project_code": "70002",
                "project_title": "ASPIRE  รัตนาธิเบศร์ 2",
                "project_url": "https://www.apdigital.net/th/condominium/aspire-rattanathibet-2",
                "project_type_slug": "condominium",
                "project_slug": "aspire-rattanathibet-2",
                "line_oaid": "https://lin.ee/KQOQR2p"
            }, {
                "project_code": "60010",
                "project_title": "ASPIRE  สุขุมวิท-อ่อนนุช",
                "project_url": "https://www.apdigital.net/th/condominium/aspire-sukhumvit-onnut",
                "project_type_slug": "condominium",
                "project_slug": "aspire-sukhumvit-onnut",
                "line_oaid": "@812iouln"
            }, {
                "project_code": "60035",
                "project_title": "Aspire Sukumvit Rama4",
                "project_url": "https://www.apdigital.net/th/condominium/aspire-sukumvit-rama4",
                "project_type_slug": "condominium",
                "project_slug": "aspire-sukumvit-rama4",
                "line_oaid": ""
            }]
        };
        let response = JSON.parse(JSON.stringify(json));
        return response;
    }
    else {
        if(lang && lang !== 'undefined' && project_type && project_type !== 'undefined')
        {
            const response = await fetch(Config.url.AP_API_URL + '/api/projects/urls?lang=' + lang + '&project_type=' + project_type, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'x-api-key': Config.AP_API_KEY
                }
            });

            if(response.ok) {
                return response.json();
            }
            else {
                return response.json().then(err => {
                    let msg = err.message;
                    if(msg instanceof Array) {
                        toast.error(msg.join(', '));
                    }
                    else {
                        toast.error(err.message);
                    }
                });
            }
        }
    }
}
export async function getProjectCodeImport(lang, project_type) {
    if(isMockupAPI) {
        let json = {
            "statusCode": 200,
            "message": "display information successfully!",
            "code": "success",
            "data": [{
                "project_code": "70002",
                "project_title": "ASPIRE  รัตนาธิเบศร์ 2",
                "project_url": "https://www.apdigital.net/th/condominium/aspire-rattanathibet-2",
                "project_type_slug": "condominium",
                "project_slug": "aspire-rattanathibet-2",
                "line_oaid": "https://lin.ee/KQOQR2p"
            }, {
                "project_code": "60010",
                "project_title": "ASPIRE  สุขุมวิท-อ่อนนุช",
                "project_url": "https://www.apdigital.net/th/condominium/aspire-sukhumvit-onnut",
                "project_type_slug": "condominium",
                "project_slug": "aspire-sukhumvit-onnut",
                "line_oaid": "@812iouln"
            }, {
                "project_code": "60035",
                "project_title": "Aspire Sukumvit Rama4",
                "project_url": "https://www.apdigital.net/th/condominium/aspire-sukumvit-rama4",
                "project_type_slug": "condominium",
                "project_slug": "aspire-sukumvit-rama4",
                "line_oaid": ""
            }]
        };
        let response = JSON.parse(JSON.stringify(json));
        return response;
    }
    else {
        if (lang && lang !== 'undefined' && project_type && project_type !== 'undefined') {
            const response = await fetch(Config.url.AP_API_URL + '/api/projects/urls?lang=' + lang + '&project_type=' + project_type, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'x-api-key': Config.AP_API_KEY
                }
            });

            return response.json();
        }
    }
}

export async function getCampaign(params) {
    if(isMockupAPI) {
        let json = {
            "statusCode": 200,
            "message": "display information successfully!",
            "code": "success",
            "data": [{
                "promotions": [{
                    "campaign_id": "0276P01",
                    "campaign_name": "LP1_BUYNOW_CD2_Life Ladprao_"
                }, {
                    "campaign_id": "0308P01",
                    "campaign_name": "SUPER SAVE_CD1_แอสปาย เอราวัณ ไพร์ม_"
                }, {"campaign_id": "0304P01", "campaign_name": "RTB2_Oct2021_CD1_Aspire รัตนาธิเบศร์ 2_"}]
            }]
        };
        let response = JSON.parse(JSON.stringify(json));
        return response;
    }
    else {
        let url = Config.url.AP_API_URL + '/api/projects/campaigns?lang=' + params.langId + '&limit=2000';

        if (params.projectType) {
            url += '&project_type=' + params.projectType;
        }
        if (params.projectCode) {
            url += '&project_code=' + params.projectCode;
        }
        if (params.campaignDate) {
            url += '&campaign_date=' + dateYMD(params.campaignDate, '-');
        }
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-key': Config.AP_API_KEY
            }
        });

        if (response.ok) {
            return response.json();
        } else {
            return response.json().then(err => {
                let msg = err.message;
                if (msg instanceof Array) {
                    toast.error(msg.join(', '));
                } else {
                    toast.error(err.message);
                }
            });
        }
    }
}
export async function getCampaignImport(params) {
    if(isMockupAPI) {
        let json = {
            "statusCode": 200,
            "message": "display information successfully!",
            "code": "success",
            "data": [{
                "promotions": [{
                    "campaign_id": "0276P01",
                    "campaign_name": "LP1_BUYNOW_CD2_Life Ladprao_"
                }, {
                    "campaign_id": "0308P01",
                    "campaign_name": "SUPER SAVE_CD1_แอสปาย เอราวัณ ไพร์ม_"
                }, {"campaign_id": "0304P01", "campaign_name": "RTB2_Oct2021_CD1_Aspire รัตนาธิเบศร์ 2_"}]
            }]
        };
        let response = JSON.parse(JSON.stringify(json))
        return response;
    }
    else {
        let url = Config.url.AP_API_URL + '/api/projects/campaigns?lang=' + params.langId + '&limit=2000';

        if (params.projectType) {
            url += '&project_type=' + params.projectType;
        }
        if (params.projectCode) {
            url += '&project_code=' + params.projectCode;
        }
        if (params.campaignDate) {
            url += '&campaign_date=' + dateYMD(params.campaignDate, '-');
        }
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-key': Config.AP_API_KEY
            }
        });

        return response.json();
    }
}

export async function getPromotion(params) {
    if(isMockupAPI) {
        let json = {
            "statusCode": 200,
            "message": "display information successfully!",
            "code": "success",
            "data": [{
                "promotion_name": "บ้านต่างจังหวัด",
                "promotion_slug": "apitown-บ้านต่างจังหวัด",
                "promotion_url": "https://www.apdigital.net/th/promotion/townhome/apitown-บ้านต่างจังหวัด",
                "project_type": "",
                "project_type_slug": "",
                "campaign_type": "all",
                "campaign_id": "0300B01",
                "campaign_name": "Pleno_ad content Q4_2021_Brand_TH_Apitown_อภิทาวน์",
                "bu_type": "townhome",
                "promotion_started_at": "2021-09-22 00:00:00",
                "promotion_ended_at": "2030-12-01 00:00:00"
            }, {
                "promotion_name": "บ้านและคอนโด 2025 (TH)",
                "promotion_slug": "house-and-condo-expo",
                "promotion_url": "https://www.apdigital.net/th/promotion/townhome/house-and-condo-expo",
                "project_type": "",
                "project_type_slug": "",
                "campaign_type": "all",
                "campaign_id": "0398A01",
                "campaign_name": "SMS Automation_All_CD1_CD2_SDH_TH_",
                "bu_type": "townhome",
                "promotion_started_at": "2022-01-13 07:00:00",
                "promotion_ended_at": "2029-12-31 07:00:00"
            }, {
                "promotion_name": "โฮมออฟฟิศ เพื่อธุรกิจของคุณ",
                "promotion_slug": "district-โฮมออฟฟิศ-เพื่อธุรกิจของคุณ",
                "promotion_url": "https://www.apdigital.net/th/promotion/townhome/district-โฮมออฟฟิศ-เพื่อธุรกิจของคุณ",
                "project_type": "",
                "project_type_slug": "",
                "campaign_type": "all",
                "campaign_id": "0300B02",
                "campaign_name": "Pleno_ad content Q4_2021_Brand_TH_District_District",
                "bu_type": "townhome",
                "promotion_started_at": "2021-09-22 00:00:00",
                "promotion_ended_at": "2030-12-01 00:00:00"
            }]
        };
        let response = JSON.parse(JSON.stringify(json));
        return response;
    }
    else {
        let url = Config.url.AP_API_URL + '/api/promotions/urls?lang=' + params.langId;

        if (params.buTypeId) {
            url += '&bu_type=' + params.buTypeId;
        }
        if (params.campaignTypeId) {
            url += '&campaign_type=' + params.campaignTypeId;
        }
        if (params.campaignId) {
            url += '&campaign_id=' + params.campaignId;
        }
        if (params.campaignDate) {
            url += '&campaign_date=' + dateYMD(params.campaignDate, '-');
        }
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-key': Config.AP_API_KEY
            }
        });

        if (response.ok) {
            return response.json();
        } else {
            return response.json().then(err => {
                let msg = err.message;
                if (msg instanceof Array) {
                    toast.error(msg.join(', '));
                } else {
                    toast.error(err.message);
                }
            });
        }
    }
}
export async function getPromotionImport(lang, campaign_type, bu_type, campaign_date) {
    if(isMockupAPI) {
        let json = {
            "statusCode": 200,
            "message": "display information successfully!",
            "code": "success",
            "data": [{
                "promotion_name": "บ้านต่างจังหวัด",
                "promotion_slug": "apitown-บ้านต่างจังหวัด",
                "promotion_url": "https://www.apdigital.net/th/promotion/townhome/apitown-บ้านต่างจังหวัด",
                "project_type": "",
                "project_type_slug": "",
                "campaign_type": "all",
                "campaign_id": "0300B01",
                "campaign_name": "Pleno_ad content Q4_2021_Brand_TH_Apitown_อภิทาวน์",
                "bu_type": "townhome",
                "promotion_started_at": "2021-09-22 00:00:00",
                "promotion_ended_at": "2030-12-01 00:00:00"
            }, {
                "promotion_name": "บ้านและคอนโด 2025 (TH)",
                "promotion_slug": "house-and-condo-expo",
                "promotion_url": "https://www.apdigital.net/th/promotion/townhome/house-and-condo-expo",
                "project_type": "",
                "project_type_slug": "",
                "campaign_type": "all",
                "campaign_id": "0398A01",
                "campaign_name": "SMS Automation_All_CD1_CD2_SDH_TH_",
                "bu_type": "townhome",
                "promotion_started_at": "2022-01-13 07:00:00",
                "promotion_ended_at": "2029-12-31 07:00:00"
            }, {
                "promotion_name": "โฮมออฟฟิศ เพื่อธุรกิจของคุณ",
                "promotion_slug": "district-โฮมออฟฟิศ-เพื่อธุรกิจของคุณ",
                "promotion_url": "https://www.apdigital.net/th/promotion/townhome/district-โฮมออฟฟิศ-เพื่อธุรกิจของคุณ",
                "project_type": "",
                "project_type_slug": "",
                "campaign_type": "all",
                "campaign_id": "0300B02",
                "campaign_name": "Pleno_ad content Q4_2021_Brand_TH_District_District",
                "bu_type": "townhome",
                "promotion_started_at": "2021-09-22 00:00:00",
                "promotion_ended_at": "2030-12-01 00:00:00"
            }]
        };
        let response = JSON.parse(JSON.stringify(json));
        return response;
    }
    else {
        let url = Config.url.AP_API_URL + '/api/promotions/urls?lang=' + lang + '&campaign_type=' + campaign_type + '&bu_type=' + bu_type;

        if (campaign_date) {
            url += '&campaign_date=' + (campaign_date ? dateYMD(campaign_date, '-') : '');
        }
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-key': Config.AP_API_KEY
            }
        });

        return response.json();
    }
}

export async function getHashtag() {
    const response = await fetch(Config.url.API_URL + '/api/hashtag/listingName', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}

export async function getMasterUrl() {
    const response = await fetch(Config.url.API_URL + '/api/masterUrl/listingName', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getPlatformAll() {
    const response = await fetch(Config.url.API_URL +'/api/adsPlatform/listingAll', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export function showPlatform(items) {
    let result = [];
    if(items) {
        items.map(item => {
            if(item.platform) {
                result.push({
                    name: item.platform.name
                });
            }
        });
    }
    return result;
}

export async function getBGZone(params) {
    if(isMockupAPI) {
        let json = {
            "statusCode": 200,
            "message": "display information successfully!",
            "code": "success",
            "data": {
                "zones": [{
                    "zone_name": "คอนโด อโศก - พระราม 4",
                    "zone_status": "active",
                    "zone_project_type_title": "คอนโดมิเนียม",
                    "zone_project_type_slug": "condominium",
                    "zone_url": "https://www.apdigital.net/th/condominium/zone-page/condo-asoke-rama-4",
                    "zone_slug": "condo-asoke-rama-4"
                }, {
                    "zone_name": "ทาวน์โฮม ดอนเมือง - รังสิต - ลำลูกกา",
                    "zone_status": "active",
                    "zone_project_type_title": "ทาวน์โฮม",
                    "zone_project_type_slug": "townhome",
                    "zone_url": "https://www.apdigital.net/th/townhome/zone-page/townhome-donmuang-rangsit-lamlukka",
                    "zone_slug": "townhome-donmuang-rangsit-lamlukka"
                }, {
                    "zone_name": "คอนโด สุขุมวิท - อ่อนนุช",
                    "zone_status": "active",
                    "zone_project_type_title": "คอนโดมิเนียม",
                    "zone_project_type_slug": "condominium",
                    "zone_url": "https://www.apdigital.net/th/condominium/zone-page/condo-sukhumvit-onnut",
                    "zone_slug": "condo-sukhumvit-onnut"
                }]
            }
        };
        let response = JSON.parse(JSON.stringify(json));
        return response;
    }
    else {
        let url = Config.url.AP_API_URL + '/api/bg-zone?lang=' + params.langId + '&zone_project_type_slug=' + params.projectTypeId + '&zone_status=' + params.zoneStatusId;
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-key': Config.AP_API_KEY
            }
        });

        if (response.ok) {
            return response.json();
        } else {
            return response.json().then(err => {
                let msg = err.message;
                if (msg instanceof Array) {
                    toast.error(msg.join(', '));
                } else {
                    toast.error(err.message + ' : ' + err.error);
                }
            });
        }
    }
}
export async function getBGZoneImport(params) {
    if(isMockupAPI) {
        let json = {
            "statusCode": 200,
            "message": "display information successfully!",
            "code": "success",
            "data": {
                "zones": [{
                    "zone_name": "คอนโด อโศก - พระราม 4",
                    "zone_status": "active",
                    "zone_project_type_title": "คอนโดมิเนียม",
                    "zone_project_type_slug": "condominium",
                    "zone_url": "https://www.apdigital.net/th/condominium/zone-page/condo-asoke-rama-4",
                    "zone_slug": "condo-asoke-rama-4"
                }, {
                    "zone_name": "ทาวน์โฮม ดอนเมือง - รังสิต - ลำลูกกา",
                    "zone_status": "active",
                    "zone_project_type_title": "ทาวน์โฮม",
                    "zone_project_type_slug": "townhome",
                    "zone_url": "https://www.apdigital.net/th/townhome/zone-page/townhome-donmuang-rangsit-lamlukka",
                    "zone_slug": "townhome-donmuang-rangsit-lamlukka"
                }, {
                    "zone_name": "คอนโด สุขุมวิท - อ่อนนุช",
                    "zone_status": "active",
                    "zone_project_type_title": "คอนโดมิเนียม",
                    "zone_project_type_slug": "condominium",
                    "zone_url": "https://www.apdigital.net/th/condominium/zone-page/condo-sukhumvit-onnut",
                    "zone_slug": "condo-sukhumvit-onnut"
                }]
            }
        };
        let response = JSON.parse(JSON.stringify(json));
        return response;
    }
    else {
        let url = Config.url.AP_API_URL + '/api/bg-zone?lang=' + params.langId + '&zone_project_type_slug=' + params.projectTypeId + '&zone_status=' + params.zoneStatusId;
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-key': Config.AP_API_KEY
            }
        });

        return response.json();
    }
}

export async function getCombineZone(params) {
    if(isMockupAPI) {
        let json = {
            "statusCode": 200,
            "message": "display information successfully!",
            "code": "success",
            "data": {
                "zones": [{
                    "zone_name": "โซนพระราม 9 - กรุงเทพกรีฑา-รามคำแหง",
                    "zone_status": "active",
                    "zone_url": "https://www.apdigital.net/th/zone/krungthepkreetha-ramkhamhaeng",
                    "zone_slug": "krungthepkreetha-ramkhamhaeng"
                }, {
                    "zone_name": "สุขสวัสดิ์ - ประชาอุทิศ - พระราม 2",
                    "zone_status": "active",
                    "zone_url": "https://www.apdigital.net/th/zone/suksawat-prachauthit-rama2",
                    "zone_slug": "suksawat-prachauthit-rama2"
                }, {
                    "zone_name": "พระราม 9 - กรุงเทพกรีฑา-รามคำแหง",
                    "zone_status": "active",
                    "zone_url": "https://www.apdigital.net/th/zone/ramkamhauek",
                    "zone_slug": "ramkamhauek"
                }]
            }
        };
        let response = JSON.parse(JSON.stringify(json));
        return response;
    }
    else {
        let url = Config.url.AP_API_URL + '/api/combine-zone?lang=' + params.langId + '&zone_status=' + params.zoneStatusId;
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-key': Config.AP_API_KEY
            }
        });

        if (response.ok) {
            return response.json();
        } else {
            return response.json().then(err => {
                let msg = err.message;
                if (msg instanceof Array) {
                    toast.error(msg.join(', '));
                } else {
                    toast.error(err.message + ' : ' + err.error);
                }
            });
        }
    }
}
export async function getCombineZoneImport(params) {
    if(isMockupAPI) {
        let json = {
            "statusCode": 200,
            "message": "display information successfully!",
            "code": "success",
            "data": {
                "zones": [{
                    "zone_name": "โซนพระราม 9 - กรุงเทพกรีฑา-รามคำแหง",
                    "zone_status": "active",
                    "zone_url": "https://www.apdigital.net/th/zone/krungthepkreetha-ramkhamhaeng",
                    "zone_slug": "krungthepkreetha-ramkhamhaeng"
                }, {
                    "zone_name": "สุขสวัสดิ์ - ประชาอุทิศ - พระราม 2",
                    "zone_status": "active",
                    "zone_url": "https://www.apdigital.net/th/zone/suksawat-prachauthit-rama2",
                    "zone_slug": "suksawat-prachauthit-rama2"
                }, {
                    "zone_name": "พระราม 9 - กรุงเทพกรีฑา-รามคำแหง",
                    "zone_status": "active",
                    "zone_url": "https://www.apdigital.net/th/zone/ramkamhauek",
                    "zone_slug": "ramkamhauek"
                }]
            }
        };
        let response = JSON.parse(JSON.stringify(json));
        return response;
    }
    else {
        let url = Config.url.AP_API_URL + '/api/combine-zone?lang=' + params.langId + '&zone_status=' + params.zoneStatusId;
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-key': Config.AP_API_KEY
            }
        });

        return response.json();
    }
}

export async function getEventReminder(params) {
    if(isMockupAPI) {
        let json = {
            "statusCode": 200,
            "message": "display information successfully!",
            "code": "success",
            "data": [{
                "event_title": "Update Concert in August! รวม 22 คอนเสิร์ต เดือนสิงหาคม 2024",
                "event_started_at": "2024-08-24 00:00:00",
                "event_ended_at": "2024-08-25 23:59:00",
                "event_url": "https://www.apdigital.net/th/event/update-concert",
                "event_slug": "update-concert",
                "campaign_id": "0721Z09"
            }, {
                "event_title": "BANGKOK STREET PERFORMER รับสมัครศิลปินการแสดงเปิดหมวก",
                "event_started_at": "2024-09-01 00:00:00",
                "event_ended_at": "2024-09-01 23:59:00",
                "event_url": "https://www.apdigital.net/th/event/bangkok-street-performer",
                "event_slug": "bangkok-street-performer",
                "campaign_id": "1376P01"
            }, {
                "event_title": "bank-long-test",
                "event_started_at": "2024-08-20 00:00:00",
                "event_ended_at": "2024-10-26 23:59:00",
                "event_url": "https://www.apdigital.net/th/event/bank-long-test",
                "event_slug": "bank-long-test",
                "campaign_id": "0398A01"
            }]
        };
        let response = JSON.parse(JSON.stringify(json));
        return response;
    }
    else {
        let url = Config.url.AP_API_URL + '/api/event-reminder?lang=' + params.langId + '&event_date=' + params.eventDate;
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-key': Config.AP_API_KEY
            }
        });

        if (response.ok) {
            return response.json();
        } else {
            return response.json().then(err => {
                let msg = err.message;
                if (msg instanceof Array) {
                    toast.error(msg.join(', '));
                } else {
                    toast.error(err.message + ' : ' + err.error);
                }
            });
        }
    }
}
export async function getEventReminderImport(params) {
    if(isMockupAPI) {
        let json = {
            "statusCode": 200,
            "message": "display information successfully!",
            "code": "success",
            "data": [{
                "event_title": "Update Concert in August! รวม 22 คอนเสิร์ต เดือนสิงหาคม 2024",
                "event_started_at": "2024-08-24 00:00:00",
                "event_ended_at": "2024-08-25 23:59:00",
                "event_url": "https://www.apdigital.net/th/event/update-concert",
                "event_slug": "update-concert",
                "campaign_id": "0721Z09"
            }, {
                "event_title": "BANGKOK STREET PERFORMER รับสมัครศิลปินการแสดงเปิดหมวก",
                "event_started_at": "2024-09-01 00:00:00",
                "event_ended_at": "2024-09-01 23:59:00",
                "event_url": "https://www.apdigital.net/th/event/bangkok-street-performer",
                "event_slug": "bangkok-street-performer",
                "campaign_id": "1376P01"
            }, {
                "event_title": "bank-long-test",
                "event_started_at": "2024-08-20 00:00:00",
                "event_ended_at": "2024-10-26 23:59:00",
                "event_url": "https://www.apdigital.net/th/event/bank-long-test",
                "event_slug": "bank-long-test",
                "campaign_id": "0398A01"
            }]
        };
        let response = JSON.parse(JSON.stringify(json));
        return response;
    }
    else {
        let url = Config.url.AP_API_URL + '/api/event-reminder?lang=' + params.langId + '&event_date=' + params.eventDate;
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-key': Config.AP_API_KEY
            }
        });

        return response.json();
    }
}

export async function getStaticPage(params) {
    if(isMockupAPI) {
        let json = {
            "statusCode": 200,
            "message": "display information successfully!",
            "code": "success",
            "data": [{
                "web_page": "th-promotion",
                "web_url": "https://www.apdigital.net/th/promotion"
            }, {"web_page": "th-ap-brand", "web_url": "https://www.apdigital.net/th/ap-brand"}, {
                "web_page": "homerun",
                "web_url": "https://www.homerunproptech.com/"
            }]
        };
        let response = JSON.parse(JSON.stringify(json));
        return response;
    }
    else {
        let url = Config.url.AP_API_URL + '/api/static-page?lang=' + params.langId;
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-key': Config.AP_API_KEY
            }
        });

        if (response.ok) {
            return response.json();
        } else {
            return response.json().then(err => {
                let msg = err.message;
                if (msg instanceof Array) {
                    toast.error(msg.join(', '));
                } else {
                    toast.error(err.message + ' : ' + err.error);
                }
            });
        }
    }
}
export async function getStaticPageImport(params) {
    if(isMockupAPI) {
        let json = {
            "statusCode": 200,
            "message": "display information successfully!",
            "code": "success",
            "data": [{
                "web_page": "th-promotion",
                "web_url": "https://www.apdigital.net/th/promotion"
            }, {"web_page": "th-ap-brand", "web_url": "https://www.apdigital.net/th/ap-brand"}, {
                "web_page": "homerun",
                "web_url": "https://www.homerunproptech.com/"
            }]
        };
        let response = JSON.parse(JSON.stringify(json));
        return response;
    }
    else {
        let url = Config.url.AP_API_URL + '/api/static-page?lang=' + params.langId;
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-key': Config.AP_API_KEY
            }
        });

        return response.json();
    }
}

export async function getAdsNamingBG() {
    const response = await fetch(Config.url.API_URL +'/api/adsNamingSource/listingName', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            adsNamingId: 1
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}

export async function getGenerateType() {
    let json = {
        "result": "000",
        "message": "success",
        "data": [
            {
                "id": GENERATE_TYPE_UTM,
                "name": "UTM",
            },
            {
                "id": GENERATE_TYPE_CAMPAIGN,
                "name": "Campaign",
            },
            {
                "id": GENERATE_TYPE_ADSSET,
                "name": "Ads Set",
            }
        ]
    };
    let response = JSON.parse(JSON.stringify(json));
    return response.data;
}

export async function getCampaignTemplate(typeId) {
    const response = await fetch(Config.url.API_URL +'/api/campaignTemplate/listingName', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            typeId: typeId,
            agencyId: roles.permissionId === SUPER_ADMIN_ID ? null : roles.agencyId
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}

export async function getAdsNamingCampaign() {
    const response = await fetch(Config.url.API_URL +'/api/adsNaming/listingName', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            typeId: ADSNAMING_TYPE_CAMPAIGN
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}

export async function getAdsNamingSetName() {
    const response = await fetch(Config.url.API_URL +'/api/adsNaming/listingName', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            typeId: ADSNAMING_TYPE_SETNAME
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}

export async function getSourceTypeForParam(sourceTypeIds) {
    const response = await fetch(Config.url.API_URL +'/api/adsNamingSource/listingPreview', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            sourceTypeIds: sourceTypeIds,
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}

export async function getShortio() {
    const response = await fetch(Config.url.API_URL +'/api/shortio/view', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            id: 1
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}

export async function getQrcodeLogo() {
    const response = await fetch(Config.url.API_URL +'/api/qrcodeLogo/listingName', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        }
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}

export async function getGenerateCampaignView(id) {
    const response = await fetch(Config.url.API_URL +'/api/generateGroupCampaign/view', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            id: id
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}
export async function getMasterURLFor() {
    let json = {
        "result": "000",
        "message": "success",
        "data": [
            {
                "id": GENERATE_TYPE_PROJECT,
                "name": "Project",
            },
            {
                "id": GENERATE_TYPE_PROMOTION,
                "name": "Promotion",
            }
        ]
    };
    let response = JSON.parse(JSON.stringify(json));
    return response.data;
}

export async function getGenerateGroup() {
    const response = await fetch(Config.url.API_URL +'/api/generateGroup/listingName', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            agencyId: roles.permissionId === SUPER_ADMIN_ID ? null : roles.agencyId
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}


export async function getGenerateGroupCampaign(generateGroupId) {
    const response = await fetch(Config.url.API_URL +'/api/generateGroupCampaign/listingName', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-access-token': roles.accessToken
        },
        body: JSON.stringify({
            generateGroupId: generateGroupId
        })
    });

    if(response.ok) {
        return response.json();
    }
    else {
        return response.json().then(err => Promise.reject(err));
    }
}